import { render, staticRenderFns } from "./VerDetalleTipoMedidaModal.vue?vue&type=template&id=76a48300&"
import script from "./VerDetalleTipoMedidaModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleTipoMedidaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports